import {IProductListFilterItem, ProductListFilterItem} from "./ProductListFilterItem";
import {IAvailableFilter} from "../items/interface/Item.interface";

export class ProductListFilterItemBoolean extends ProductListFilterItem implements IProductListFilterItem {
  public static trueValueId = "true";

  public static falseValueId = "false";

  protected _value: boolean | undefined;

  public constructor(filterItemData: IAvailableFilter) {
    super(filterItemData);

    this._value = this.getValueFromResult(filterItemData);
  }

  public get value(): boolean | undefined {
    return this._value;
  }

  public set value(value: boolean | undefined) {
    this._value = value;
  }

  public get paramValue(): string {
    if (this.value !== undefined) {
      return this.value ? ProductListFilterItemBoolean.trueValueId : ProductListFilterItemBoolean.falseValueId;
    }

    return "";
  }

  public clear() {
    this._value = undefined;
  }

  public getValueFromResult(filterItemData: IAvailableFilter): boolean | undefined {
    if (filterItemData.values.length > 1) {
      return undefined;
    }

    return filterItemData.values[0]?.id === ProductListFilterItemBoolean.trueValueId;
  }

  public applyFilterItemResult(filterItemData: IAvailableFilter): void {
    this._value = this.getValueFromResult(filterItemData);
  }
}
